export default "__VITE_ASSET__4M_cOMtX__"